<template>
	<EventLayout :event="event" :subtitle="stage.title" :return-url="route('events.stages.attachment.index', event.id)" :return-label="trans('events.stages.attachment.title')">
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="update">
				<i class="fa-solid fa-save mr-2"/>
				{{ trans('general.save') }}
			</PrimaryButton>
		</template>
		<EditStage :stage="stage">
			<LabeledObject required>
				<template #label>{{ trans('events.stages.attachment.maximum') }}</template>
				<IconNumberInput v-model="stage.maximum" :min="1" :max="20" icon-class="fa-solid fa-file-pdf" full/>
			</LabeledObject>
		</EditStage>
	</EventLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import {type Event} from '@/Types/Events/Event'
import EventLayout from '@/Layouts/EventLayout.vue'
import LabeledObject from '@/Components/UI/LabeledObject.vue'
import EditStage from '@/Components/Events/Stages/EditStage.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors} from '@/Helpers/general'
import IconNumberInput from '@/Components/UI/Inputs/IconNumberInput.vue'
import {type AttachmentStage} from '@/Types/Events/Stages/AttachmentStage'

const props = defineProps<{
	event:Event,
	stage:AttachmentStage,
}>()

const event:Ref<Event> = ref(props.event)
const working:Ref<boolean> = ref(false)
const stage:Ref<AttachmentStage> = ref(props.stage)

function update():void{
	if(!working.value){
		working.value = true
		showInfo(trans('general.updating'))
		axios.patch(route('events.stages.attachment.update', {event: event.value.id, stage: stage.value.id}), stage.value).then(() => {
			showSuccess(trans('general.updated'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>